export default __webpack_public_path__ + "static/media/rebalance-history-collapse-active.26707f0f.svg";